export const MODULE_NAME = 'Map';
